import { useMemo } from 'react';
import { useUserConversationsQuery } from '@/graphql/chat';
import { useUser } from '@/services/contexts/UserContext';

export const useUnreadMessagesCount = () => {
  const { user } = useUser();
  const { conversations } = useUserConversationsQuery();

  const unreadCount = useMemo(() => {
    if (!conversations || !user?.id) return 0;

    return conversations.reduce((total, conv) => {
      const lastMessage = conv.messages?.[conv.messages.length - 1];
      const isUnread =
        lastMessage &&
        lastMessage.sender?.id !== user.id &&
        !lastMessage.isRead;
      return total + (isUnread ? 1 : 0);
    }, 0);
  }, [conversations, user?.id]);

  return unreadCount;
};